import { ApplicationConfig } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth'; 
import { routes } from "../app-routing.module";
import { environment } from "src/environments/environment";


export const statesAllowedIso3Countries = ['USA', 'MEX', 'CAN'];

export const statesAllowedIso2Countries = ['US', 'MX', 'CA'];

export const supportedLocale = [
  'en-US',
  'es-US',
  'uk-UA',
  'pt-PT',
  'fr-FR',
  'de-DE',
  'el-GR',
  'lt-LT',
  'ru-RU',
  'it-IT',
  'ro-RO',
  'no-NO',
  'es-ES',
  'da-DK',
  'pl-PL',
];

export const languageList = [
  { code: 'da-DK', cmsKey: 'DANISH' },
  { code: 'pl-PL', cmsKey: 'POLISH' },
  { code: 'en-US', cmsKey: 'ENGLISH' },
  { code: 'es-US', cmsKey: 'SPANISH' },
  { code: 'uk-UA', cmsKey: 'UKRAINIAN' },
  { code: 'pt-PT', cmsKey: 'PORTUGUESE' },
  { code: 'fr-FR', cmsKey: 'FRENCH' },
  { code: 'de-DE', cmsKey: 'GERMAN' },
  { code: 'el-GR', cmsKey: 'GREEK' },
  { code: 'lt-LT', cmsKey: 'LITHUANIAN' },
  { code: 'ru-RU', cmsKey: 'RUSSIAN' },
  { code: 'it-IT', cmsKey: 'ITALIAN' },
  { code: 'no-NO', cmsKey: 'NORWEGIAN' },
  { code: 'ro-RO', cmsKey: 'ROMANIAN' },
  { code: 'es-ES', cmsKey: 'SPANISH_SPAIN' },
];

export const displayFlashPage: boolean = false;

export const isSdfCardFlow: boolean = true;

export const localBackend: boolean = false;

export const isCardApi: boolean = true; // TODO: Logic needs to get refactored/removed, as switching is no longer necessary between sdfui and sdfuicard

export const mapiCategoryErrorCodes: any[] = [
  'MAPI-20000',
  'MAPI-30000',
  'MAPI-45000',
  'MAPI-90000',
];

export enum PageTitles {
  ESTIMATE_PAGE = 'Estimate Page',
  ESTIMATE_CONFIRM_PAGE = 'Estimate Confirmation Page',
  LOCATION_PAGE = 'Location Page',
  MORE_INFO_PAGE = 'More Info Page',
  ADDRESS_PAGE = 'Address Page',
  REGISTRATION_PAGE = 'Registration Page',
  BASIC_INFO_PAGE = 'BasicInfo Page',
  IDENTITY_PAGE = 'ID Page',
  FRAUD_PAGE = 'Fraud Page',
  SUMMARY_PAGE = 'Summary Page',
  CONFIRMATION_PAGE = 'Confirmation Page',
  TRANSACTION_STATUS_PAGE = 'Transaction Status Page',
}

export function isStatesAllowed(countryCode: string): boolean {
  if (countryCode.length > 2) {
    return statesAllowedIso3Countries.some((code) => code === countryCode);
  }
  return statesAllowedIso2Countries.some((code) => code === countryCode);
}

export function getSupportedLocale(inputLocale: string): string {
  const isSupproted = !!inputLocale
    ? supportedLocale.some(
        (locale) =>
          locale.toLocaleLowerCase() === inputLocale.toLocaleLowerCase()
      )
    : '';
  return isSupproted ? inputLocale : '';
}

export function getAssociatedLocale(lang: string): string {
  const supportedValue = supportedLocale.find((locale) =>
    locale.includes(lang)
  );
  return supportedValue ? supportedValue : '';
}